<script>
import TablePage from '@/found/components/table_page';
import Form from './components/index.vue';
// 审核
export default {
  name: 'goodsConfig',
  extends: TablePage,
  components: { Form },
  data() {
    return {
      // modalConfig: {
      //   title: '需货申请配置',
      //   width: '800px',
      //   height: '400px',
      // },
    };
  },
  async mounted() {
    await this.getConfigList('need_goods_config_list');
  },
  methods: {
    modalClick({ val, row }) {
      if (val.code === 'add') {
        this.formConfig = {
          code: val.code,
        };
        this.modalConfig = {
          ...this.modalConfig,
          width: '800px',
          height: '400px',
          title: '新增',
        };
        this.openModal();
      }
      if (val.code === 'edit') {
        this.formConfig = {
          ...val,
          row,
          companyCode: row.companyCode,
        };
        this.modalConfig.title = '编辑';
        this.openFull();
      }
    },
  },
};
</script>
